// @ts-nocheck
import React from "react";
import LegalPageLayout, { BulletList, InfoCallout, Section } from "../components/LegalPageLayout";

export default function PrivacyPolicy() {
  return (
    <LegalPageLayout
      title="Privacy Policy"
      subtitle="How Cardex collects, uses, and protects your personal information."
      updated="February 7, 2026"
    >
      <Section title="Phase 1 Notice">
        <InfoCallout title="Phase 1 Scope">
          This Privacy Policy reflects Cardex Phase 1 functionality. <strong>Cardex does NOT process 
          payments, does NOT handle shipping, and does NOT store transaction or purchase history.</strong> All 
          trades occur in person between users.
        </InfoCallout>
      </Section>

      <Section title="1. Information We Collect">
        <h3>Account Information</h3>
        <p>When you create an account, we collect:</p>
        <BulletList
          items={[
            "Username",
            "Email address",
            "Password (encrypted)",
            "Age confirmation flag (18+)",
            "Optional location (city/ZIP for local trades)"
          ]}
        />

        <h3>Messaging Data</h3>
        <BulletList
          items={[
            "Messages exchanged between users",
            "Reports submitted through moderation tools"
          ]}
        />

        <h3>Usage Data</h3>
        <BulletList
          items={[
            "IP address",
            "Device/browser info",
            "Pages viewed",
            "Feature usage (analytics)"
          ]}
        />

        <h3>What We Do NOT Collect</h3>
        <BulletList
          items={[
            "❌ No payment data",
            "❌ No shipping addresses",
            "❌ No transaction history",
            "❌ No financial information"
          ]}
        />
      </Section>

      <Section title="2. How We Use Your Information">
        <p>We use collected data to:</p>
        <BulletList
          items={[
            "Provide and improve our trading coordination platform",
            "Connect you with local traders",
            "Send important account notifications and safety alerts",
            "Enforce our Community Guidelines and 3-Strike Trust System",
            "Investigate reports and maintain community safety",
            "Analyze platform usage to improve features",
            "Comply with legal obligations"
          ]}
        />
      </Section>

      <Section title="3. Information Sharing">
        <p>We share information in limited circumstances:</p>
        <BulletList
          items={[
            "With Other Users: Your username and public profile information are visible to other traders. Email, phone, and location data are NEVER shared.",
            "Service Providers: Email services, hosting providers, and analytics tools who help operate the platform",
            "Legal Requirements: When required by law, court order, or to protect our rights and users' safety",
            "Business Transfers: In the event of a merger, acquisition, or sale of assets"
          ]}
        />
        <p><strong>We never sell your personal information to third parties.</strong></p>
      </Section>

      <Section title="4. Data Security">
        <p>We implement industry-standard security measures including:</p>
        <BulletList
          items={[
            "Encrypted data transmission (HTTPS/TLS)",
            "Password hashing with bcrypt",
            "Secure authentication with JWT tokens",
            "Regular security audits and updates"
          ]}
        />
        <p>
          However, no method of internet transmission is 100% secure. While we strive to protect your
          data, we cannot guarantee absolute security.
        </p>
      </Section>

      <Section title="5. Your Privacy Rights">
        <p>You have the right to:</p>
        <BulletList
          items={[
            "Access: Request a copy of your personal data",
            "Correction: Update inaccurate information in your account settings",
            "Deletion: Request account deletion (Account menu > Request Account Deletion)",
            "Opt-out: Unsubscribe from marketing emails (account notifications remain active)",
            "Data Portability: Receive your data in a structured, machine-readable format"
          ]}
        />
      </Section>

      <Section title="6. Cookies and Tracking">
        <p>We use cookies and similar technologies to:</p>
        <BulletList
          items={[
            "Keep you logged in",
            "Remember your preferences",
            "Analyze platform usage (with analytics tools)",
            "Improve user experience"
          ]}
        />
        <p>You can disable cookies in your browser settings, but this may limit platform functionality.</p>
      </Section>

      <Section title="7. Age Restriction (18+)">
        <p>
          <strong>Cardex is restricted to users 18 years of age or older.</strong> Age confirmation is 
          required at signup. Minors are not permitted to create or use accounts. We do not knowingly 
          collect information from anyone under 18.
        </p>
        <p>
          If you believe a minor has created an account, please report it immediately through our 
          reporting system or contact us at safety@cardexhq.com.
        </p>
      </Section>

      <Section title="8. Data Retention">
        <p>
          We retain your information for as long as your account is active or as needed to provide
          services. Report records are kept to maintain platform integrity and safety.
        </p>
        <p>
          After account deletion, most data is removed within 30 days, except where retention is required
          by law or for safety/moderation purposes.
        </p>
      </Section>

      <Section title="9. International Users">
        <p>
          Cardex operates from the United States. If you access the platform from outside the US, your
          information may be transferred to and stored in the United States, which may have different data
          protection laws.
        </p>
      </Section>

      <Section title="10. Third-Party Links">
        <p>
          Our platform may contain links to external sites (TCG convention websites, card shops, etc.) for 
          reference. We are not responsible for the privacy practices of these sites. Please review their 
          privacy policies separately.
        </p>
      </Section>

      <Section title="11. Changes to Privacy Policy">
        <p>
          We may update this policy periodically. We will notify users of material changes via email or
          platform notification. Continued use after changes constitutes acceptance.
        </p>
      </Section>

      <Section title="12. Contact Us">
        <p>For privacy questions, data requests, or concerns, contact us at:</p>
        <p><strong>support@cardexhq.com</strong></p>
      </Section>

      <p className="legal-footer-text">
        Your privacy matters to us. We are committed to protecting your personal information and being
        transparent about our practices.
      </p>
    </LegalPageLayout>
  );
}
